import {call, select} from '@redux-saga/core/effects';
import {getToken} from 'api/auth';

function* callSagaIfHasToken(saga) {
  const token = yield select(getToken);
  if (token) {
    yield call(saga);
  }
}

export {callSagaIfHasToken};
